module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"VIN":"VIN","registrationEnd":"End of Registration","truckUpdated":"Truck updated"},"de":{"VIN":"VIN","registrationEnd":"Registrierungsende","truckUpdated":"Lastwagen aktualisiert"},"fr":{"VIN":"VIN","registrationEnd":"Fin d\u0027enregistrement","truckUpdated":"Camion mis à jour"},"it":{"VIN":"VIN","registrationEnd":"Fine registrazione","truckUpdated":"Camion aggiornato"}}')
  delete Component.options._Ctor
}
